// ─────────────────────────────────────────────────────────────────────────────
// tokens/radii.ts
//
// Cinco níveis de border-radius.
// Cards e containers: radiusLg
// Botões e inputs:    radiusMd
// Chips e badges:     radiusPill
// ─────────────────────────────────────────────────────────────────────────────

export const radiusSm   = '4px';
export const radiusMd   = '6px';
export const radiusLg   = '10px';
export const radiusXl   = '16px';
export const radiusPill = '9999px';

export const radii = {
  sm:   radiusSm,
  md:   radiusMd,
  lg:   radiusLg,
  xl:   radiusXl,
  pill: radiusPill,
} as const;
